import React ,{ Component }from "react";
import { FiCast , FiLayers , FiUsers , FiMonitor,FiDollarSign, FiPhone, FiSmartphone, FiEye } from "react-icons/fi";

const ServiceList = [

    {
        icon: <FiMonitor />,
        title: 'Front-End Development',
        description: 'Crafting responsive, high-performance user interfaces with React.js, Vue.js, and modern CSS frameworks.'
    },
    {
        icon: <FiLayers />,
        title: 'Back-End Development',
        description: 'Architecting robust RESTful APIs and microservices using Laravel, Go (Fiber), and CodeIgniter.'
    },
    { 
        icon: <FiSmartphone />,
        title: 'Mobile Development',
        description: 'Building cross-platform and native mobile applications using Flutter, Capacitor, Java, and Kotlin.'
    },
    {
        icon: <FiEye />,
        title: 'UI/UX',
        description: 'Designing intuitive interfaces with a focus on layout, color theory, and holistic user experience.'
    },
    {
        icon: <FiUsers />,
        title: 'Digital Marketing',
        description: 'Driving user acquisition and engagement through Google Ads, social media campaigns, and ASO strategies.'
    },
    { 
        icon: <FiDollarSign />,
        title: 'Digital Monetization',
        description: 'Implementing monetization strategies via AdMob, Meta Audience Network, and AppLovin to maximize app revenue.'
    },

   
]


interface Props {
    column?: string;
    item?: any;
}

class ServiceThree extends Component<Props>{
    render(): React.ReactNode{
        const {column } = this.props;
        const ServiceContent = ServiceList.slice(0 , this.props.item);
        
        return(
            <React.Fragment>
                <div className="row">
                    {ServiceContent.map( (val , i) => (
                        <div className={`${column}`} key={i}>
   
                                <div className="service service__style--2">
                                    <div className="icon">
                                        {val.icon}
                                    </div>
                                    <div className="content">
                                        <h3 className="title">{val.title}</h3>
                                        <p>{val.description}</p>
                                    </div>
                                </div>
                          
                        </div>
                    ))}
                </div>
            </React.Fragment>
        )
    }
}
export default ServiceThree;
